import { render, staticRenderFns } from "./QuestionAllList.vue?vue&type=template&id=2c6056ea&scoped=true&"
import script from "./QuestionAllList.vue?vue&type=script&lang=js&"
export * from "./QuestionAllList.vue?vue&type=script&lang=js&"
import style0 from "./QuestionAllList.vue?vue&type=style&index=0&id=2c6056ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6056ea",
  null
  
)

export default component.exports